// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const { navigate } = require('client-v2/common/state/router/actions')

// Action dispatchers

function navigateToArticleSearch(text) {
  return async function (dispatch) {
    await businessEvents.trackSegment('search-topic', {
      text
    })
    dispatch(navigate(searchArticlesHref(text)))
  }
}

// Helpers

function searchArticlesHref(query) {
  return `/search/${encodeURIComponent(query)}`
}

module.exports = {
  navigateToArticleSearch
}
